import React from "react";

const LangImg = ({src, alt, onClick}) => {
    return <img src={src} style={{ width: '25px', marginLeft: '5px', cursor: 'pointer' }} alt={alt} onClick={onClick} />
}

export default LangImg;